import React from 'react';
import { reduxForm } from 'redux-form';
import WaitlistSuccessModal from './waitlist_success_modal.jsx';
import styles from './waitlist.css';
import { Form, FormGroup, FormControl, Button, Jumbotron } from 'react-bootstrap';

class Waitlist extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      email: '',
      userType: null,
    };

    this.updateEmail = this.updateEmail.bind(this);
    this.handleHostClick = this.handleHostClick.bind(this);
    this.handleUserClick = this.handleUserClick.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  updateEmail(e) {
    this.setState({email: e.currentTarget.value});
  }

  handleHostClick(e) {
    e.preventDefault();

    if (this.state.userType === 'host') {
      this.setState({userType: null})
    } else {
      this.setState({userType: 'host'})
    }
  }

  handleUserClick(e) {
    e.preventDefault();

    if (this.state.userType === 'user') {
      this.setState({userType: null})
    } else {
      this.setState({userType: 'user'})
    }
  }

  handleFormSubmit(event) {
    event.preventDefault();
    if (this.state.email.length > 0) {
      this.props.onAddToWaitlist(this.state.email, this.state.userType);
    }
  }

  renderWaitlistModal() {
    if (this.props.waitlistSuccess) {
      return(
        <WaitlistSuccessModal
          waitlistEmail={this.props.email}
          fetchUserCount={this.props.fetchUserCount}
          waitlistCount={this.props.waitlistCount}
          addToUserCount={this.props.addToUserCount}
        />
      );
    }
  }

  renderUserButtons() {
    var hostClass = '', userClass = '';

    if (this.state.userType === 'host') {
      hostClass = 'active-btn'
    } else if (this.state.userType === 'user') {
      userClass = 'active-btn'
    }

    return(
      <div className='user-btns'>
        <Button className={"user-btn " + hostClass} onClick={this.handleHostClick}>
          Hosting
        </Button>
        <Button className={"user-btn " + userClass}  onClick={this.handleUserClick}>
          Renting
        </Button>
      </div>
    )
  }

  render() {
    return (
      <div className='waitlist-container' style={{textAlign: 'center'}}>
        <Jumbotron>
          <div className='mdl-typography--text-center'>
            <div className='card-box'>
              <h1>Tinbin</h1>
              <p>
                Join the new market place matching hosts with extra space to potential renters
              </p>

              <Form className='waitlist-form' onSubmit={this.handleFormSubmit}>
                <FormGroup style={{textAlign: 'center'}}>
                  <FormControl
                    className='email-input'
                    type='email'
                    placeholder='Enter email address'
                    onChange={this.updateEmail}
                  />
                </FormGroup>
                <div> Interested in: </div>
                {this.renderUserButtons()}

                <Button
                type='submit'
                bsStyle='primary'
                className='waitlist-submit-btn'
                >
                  Get Early Access
                </Button>
              </Form>
            </div>
          </div>
        </Jumbotron>

        {this.renderWaitlistModal()}
      </div>
    );
  }
}

Waitlist = reduxForm({form: 'Waitlist'})(Waitlist);

export default Waitlist;



// WEBPACK FOOTER //
// ./src/views/components/waitlist/waitlist.jsx